import { useState, type ReactNode } from 'react'
import { VideoPlayerModal, type VideoLectureItem } from './VideoPlayerModal'

export function isVideoSource(source: string) {
  try { return /\.(?:mp4|webm|mov|m4v|ogv)(?:[?&#]|$)/i.test(decodeURIComponent(source)) } catch { return false }
}

export function ClinicalVideoPlayer({ source, title, onClose }: { source: string; title: string; onClose: () => void }) {
  const lesson: VideoLectureItem = { id: `clinical-video:${source}`, title, duration: 'Ready to play', subject: 'Clinical media', videoUrl: source }
  return <VideoPlayerModal lesson={lesson} playlist={[lesson]} libraryName="iMed" libraryIcon="./imed-brand-icon.png" folderName="Clinical media" onClose={onClose} onSelectLesson={() => undefined}/>
}

/** Rich provider HTML keeps its media URLs; clicks open the same study player. */
export function VideoMediaBoundary({ children }: { children: ReactNode }) {
  const [selected, setSelected] = useState<{ source: string; title: string } | null>(null)
  return <div style={{ display: 'contents' }} onClickCapture={event => {
    const target = event.target as HTMLElement
    if (target.closest('.imed-video-player')) return
    const video = target.closest('video')
    const anchor = target.closest('a[href]') as HTMLAnchorElement | null
    const source = video?.currentSrc || video?.src || video?.querySelector('source')?.src || (anchor && isVideoSource(anchor.href) ? anchor.href : '')
    if (!source) return
    event.preventDefault(); event.stopPropagation(); video?.pause()
    setSelected({ source, title: video?.getAttribute('aria-label') || anchor?.textContent?.trim() || 'Clinical video' })
  }}>
    {children}
    {selected && <ClinicalVideoPlayer {...selected} onClose={() => setSelected(null)}/>}
  </div>
}
